module.exports = __webpack_public_path__ + "img/frame (132).81a4beff.jpg";